import { useMutation } from 'react-query';
import { toastr } from 'react-redux-toastr';
import HudVoucherService from '../../services/hudVoucherService';
import messages from './messages';

const useUndoSubmittedChangesMutation = ({
  organizationId,
  propertyId,
  hudVoucherId,
  intl,
  setSubmissionStatusOverride,
  setPart6TotalOverride,
  invalidateVoucherDetailQueries,
}) => {
  return useMutation(
    () => {
      const service = new HudVoucherService();
      return service.undoSubmittedVoucherChanges(
        organizationId,
        propertyId,
        hudVoucherId,
      );
    },
    {
      onSuccess: async () => {
        setSubmissionStatusOverride('Submitted');
        setPart6TotalOverride(null);
        await invalidateVoucherDetailQueries();
        toastr.success(
          intl.formatMessage(messages.undoSubmittedChangesSuccessTitle),
          intl.formatMessage(messages.undoSubmittedChangesSuccessBody),
        );
      },
      onError: (error) => {
        const msg =
          error?.message ||
          error?.error ||
          'Failed to undo voucher changes. Please try again.';
        toastr.error('Error', msg);
      },
    },
  );
};

export default useUndoSubmittedChangesMutation;
